import React, { Component } from 'react';
import { ColorPicker } from './ColorPicker';
import Spinner from './Spinner';
import './LogoEditor.css';

export class LogoEditor extends Component {
  constructor(props) {
    super();
    this.state = {
      text: 'DAZN',
      loadingLogo: true,
      loadingLogoError: null,
      color: '#FFFFFF',
      backgroundColor: 'transparent',
      displayColorPicker: false
    };
  }

  componentDidMount() {
    this.loadLogo();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loadingLogo) {
      this.loadLogo();
    }
  }

  loadLogo = () => {
    const UNKNOWN_ERROR = 'An error occurred building your logo';
    const BADWORDS_ERROR = 'Good manners required!';

    const text = this.state.text;
    const encodedText = encodeURIComponent(this.state.text);
    if (!text) {
      return this.setState({
        loadingLogo: false,
        loadingLogoError: 'Write something in the box above!'
      });
    }

    const color = encodeURIComponent(this.state.color);
    const backgroundColor = encodeURIComponent(this.state.backgroundColor);

    const logoUrl = `https://logo.daznplatform.com/${encodedText}.svg?fontColor=${color}&backgroundColor=${backgroundColor}`;

    fetch(logoUrl, { method: 'GET' })
      .then(response => {
        if (text !== this.state.text) return; // Avoid race conditions
        if (response.status === 403) {
          this.setState({
            loadingLogo: false,
            loadingLogoError: BADWORDS_ERROR
          });
          return null;
        } else if (!response.ok) {
          this.setState({
            loadingLogo: false,
            loadingLogoError: UNKNOWN_ERROR
          });
          return null;
        } else {
          this.setState({ logoUrl, loadingLogo: false });
          return response.blob();
        }
      })
      .then(svgBlob => {
        if (svgBlob) {
          this.props.handleLogoUpdate(
            svgBlob,
            `custom-dazn-logo-${this.state.text}`
          );
        }
      })
      .catch(error => {
        if (text !== this.state.text) return; // Avoid race conditions
        this.setState({ loadingLogo: false, loadingLogoError: UNKNOWN_ERROR });
      });
  };

  handleInputChange = event => {
    const text = event.target.value;
    this.setState({ text, loadingLogo: true, loadingLogoError: null });
  };

  handleColorChangeComplete = color => {
    this.setState({
      color: color.hex,
      loadingLogo: true,
      loadingLogoError: null
    });
  };

  handleBackgroundColorChangeComplete = color => {
    this.setState({
      backgroundColor: color.hex,
      loadingLogo: true,
      loadingLogoError: null
    });
  };

  renderLogo() {
    return (
      <img
        src={this.state.logoUrl}
        alt={`Generated logo for ${this.state.text}`}
      />
    );
  }

  renderLoading() {
    return (
      <div className="LogoEditor__Loading">
        <Spinner className="LogoEditor__Spinner" />
      </div>
    );
  }

  renderError() {
    return (
      <h1 className="LogoEditor__Message">{this.state.loadingLogoError}</h1>
    );
  }

  render() {
    return (
      <div className="LogoEditor">
        <input
          className="LogoEditor__input"
          onChange={this.handleInputChange}
          value={this.state.text}
          maxLength="4"
        />

        <div className="LogoEditor_ColorPickers">
          <ColorPicker
            color={this.state.backgroundColor}
            onChangeComplete={this.handleBackgroundColorChangeComplete}
            title="Background color"
          />
          <ColorPicker
            color={this.state.color}
            onChangeComplete={this.handleColorChangeComplete}
            title="Logo color"
          />
        </div>

        <div className="LogoEditor__logo">
          <div className="LogoEditor__logoContent">
            {this.state.loadingLogo
              ? this.renderLoading()
              : this.state.loadingLogoError
              ? this.renderError()
              : this.renderLogo()}
          </div>
        </div>
      </div>
    );
  }
}
